module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgxNiA3MjBhNDggNDggMCAwIDEgMCA5NmgtNjA4YTQ4IDQ4IDAgMCAxIDAtOTZoNjA4eiBtMC0yNTZhNDggNDggMCAwIDEgMCA5NmgtNjA4YTQ4IDQ4IDAgMCAxIDAtOTZoNjA4eiBtMC0yNTZhNDggNDggMCAwIDEgMCA5NmgtNjA4YTQ4IDQ4IDAgMCAxIDAtOTZoNjA4eiIgZmlsbD0iIzAiIHAtaWQ9IjY3NSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Hamburger-outlined.svg
// module id = P62Q
// module chunks = 73